import React, { useState, createContext } from 'react';

export const DocsContext = createContext();

export const DocsProvider = (props) => {
  const [docs, setDocs] = useState([]);
  return <DocsContext.Provider value={[docs, setDocs]}>{props.children}</DocsContext.Provider>;
};
